import React from "react";
import { css } from "emotion";
import ItemAvatar from "./ItemAvatar";

const AvatarPicker = props => {
  const tabsAvatar = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16];
  return (
    <div
      className={css`
        margin-top: 20px;
        width: 100%;
        display: flex;
        display: flex;
        flex-wrap: wrap;
      `}>
      {tabsAvatar.map((item, key) => {
        return (
          <ItemAvatar
            key={key}
            onChoose={props.onChooseAvatar}
            isSelect={props.avatarChoose}
            item={item}
          />
        );
      })}
    </div>
  );
};
export default AvatarPicker;
